import { render, staticRenderFns } from "./ClaioSchemaPreview.vue?vue&type=template&id=4c57413d&scoped=true&"
import script from "./ClaioSchemaPreview.vue?vue&type=script&lang=ts&"
export * from "./ClaioSchemaPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioSchemaPreview.vue?vue&type=style&index=0&id=4c57413d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c57413d",
  null
  
)

export default component.exports